import API from '@/services/api'

export default {
  getIsos() {
    return API.get('/isos')
  },
  getIso(id) {
    return API.get('/isos/' + id)
  }
}
